import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../services/auth-service.service';


@Component({
    selector: 'app-chatlearn',
    templateUrl: './chat-learn.component.html',
    styleUrls: ['./chat-learn.component.scss']
})
export class ChatLearnComponent implements OnInit {
    isLoading: boolean = false;
    instruction: string = '';

    constructor(
        private toastr: ToastrService,
        private auth: AuthServiceService    ) { }

    ngOnInit(): void {
    }

    submit():any {
        if (this.instruction == '') {
            return this.toastr.error("Please Fill a Instruction")
        }

        this.isLoading = true
        this.auth.chatAddInstruction({
            instruction: this.instruction
        }).subscribe(() => {
            this.isLoading = false
            this.instruction = ''
            this.toastr.success('Successfully added Instructions')
        }, () => {
            this.isLoading = false
            this.toastr.error('Failed to add Instructions')

        })
    }
}